import React, { Component } from 'react';
import { connect } from 'react-redux';

import MaskedInput from 'react-text-mask';

import ErrorMessage from '../error_message/ErrorMessage';
import ButtonStage from '../../standard/button_stage/ButtonStage';
import {
  changeContactAttr,
  finishPurchase,
  validatorHandlerBlur,
  clearInfosProspect,
} from '../../../actions/purchaseActions';
import { getAddressData } from '../../../apiCalls';
import { states } from '../../../utils/address';

class PurchaseContactMobile extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.states = states;
  }

  handleChange(e) {
    if (e.target.name === 'cep' && e.target.value.length === 10) {
      getAddressData(e.target.value);
    }
    this.props.changeContactAttr({ name: e.target.name, value: e.target.value });
  }

  getDestinationName() {
    const destinations = this.props.destinations
    const destination = destinations.find((destination) => destination.slug === this.props.destination)
    const destinationName = destination && destination.name

    return destinationName
  }

  render() {
    const formErrors = this.props.errors.contact;
    return (
      <div
        className="card-contato-compra mobile"
        style={{ display: this.props.stagePurchase !== 3 && this.props.mobile ? 'none' : 'block' }}
      >
        <div className="box-item">
          <div className="body-box-item">
            <h4 className="title">Dados do contato da compra</h4>
            <span className="guidance-mobile">
              Preencha os campos abaixo com seus melhores dados, para recebimento de todas informações
              <br />a respeito do seu seguro viagem.
            </span>
            <form action="" method="" className="form-contato-compra">
              <input type="hidden" name="destination" value={this.getDestinationName()} data-perry-destination />
              <input type="hidden" name="departure_date" value={this.props.departure_date} data-perry-departure-date />
              <input type="hidden" name="return_date" value={this.props.return_date} data-perry-return-date />

              <div className="row-contatos-mobile contact">
                <div className="grupo-campo-mobile gcontato">
                  <input
                    type="text"
                    name="contact_name"
                    placeholder="Nome do Contato"
                    value={this.props.contact.contact_name}
                    onChange={this.handleChange}
                    className={formErrors.contact_name ? 'with-error' : ''}
                    onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_name')}
                    data-perry-name
                  />
                  <ErrorMessage anchor={`contact_contact_name`} field1="contact" field2="contact_name" />
                </div>
                <div className="grupo-campo-mobile gemail">
                  <input
                    type="email"
                    name="email"
                    value={this.props.contact.email}
                    onChange={this.handleChange}
                    placeholder="E-mail"
                    className={formErrors.email ? 'with-error' : ''}
                    onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_email')}
                    data-perry-email
                  />
                  <ErrorMessage anchor={`contact_email`} field1="contact" field2="email" />
                </div>
                <div className="grupo-campo-mobile g-telefone">
                  <MaskedInput
                    guide={true}
                    name="phone_number"
                    inputMode="numeric"
                    value={this.props.contact.phone_number}
                    type="tel"
                    placeholder="Telefone"
                    mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d?/]}
                    onChange={this.handleChange}
                    className={formErrors.phone_number ? 'with-error' : ''}
                    onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_phone')}
                    data-perry-phone
                  />
                  <ErrorMessage anchor={`contact_phone_number`} field1="contact" field2="phone_number" />
                  {this.props.prospect.exist && (
                    <button className="transfer-infos" onClick={this.props.clearInfosProspect} type="button">
                      Limpar campos
                    </button>
                  )}
                </div>
              </div>
              <div className="title address">Endereço</div>
              <div className="row-contatos-mobile">
                <div className="grupo-campo-mobile">
                  <MaskedInput
                    type="tel"
                    name="cep"
                    inputMode="numeric"
                    value={this.props.contact.cep}
                    onChange={this.handleChange}
                    guide={true}
                    placeholder="CEP"
                    className={formErrors.cep ? 'with-error' : ''}
                    mask={[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                    onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_cep')}
                  />
                  <ErrorMessage anchor={`contact_cep`} field1="contact" field2="cep" />
                </div>
                <div className="grupo-campo-mobile gendereco">
                  <input
                    type="text"
                    name="address"
                    placeholder="Endereço"
                    value={this.props.contact.address}
                    onChange={this.handleChange}
                    className={formErrors.address ? 'with-error' : ''}
                    onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_address')}
                    maxLength={50}
                  />
                  <ErrorMessage anchor={`contact_address`} field1="contact" field2="address" />
                </div>
                <div className="grupo-campo-mobile gnumero">
                  <input
                    type="text"
                    name="number"
                    placeholder="Número"
                    className={formErrors.number ? 'with-error' : ''}
                    value={this.props.contact.number}
                    onChange={this.handleChange}
                    onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_number')}
                  />
                  <ErrorMessage anchor={`contact_number`} field1="contact" field2="number" />
                </div>
                <div className="grupo-campo-mobile gcomplemento">
                  <input
                    type="text"
                    name="complement"
                    placeholder="Complemento"
                    className={formErrors.complement ? 'with-error' : ''}
                    value={this.props.contact.complement}
                    onChange={this.handleChange}
                    maxLength={20}
                  />
                  <ErrorMessage anchor={`contact_complement`} field1="contact" field2="complement" />
                </div>
              </div>

              <div className="row-contatos-mobile">
                <div className="grupo-campo-mobile gbairro">
                  <input
                    type="text"
                    name="district"
                    placeholder="Bairro"
                    className={formErrors.district ? 'with-error' : ''}
                    value={this.props.contact.district}
                    onChange={this.handleChange}
                    onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_district')}
                    maxLength={50}
                  />
                  <ErrorMessage anchor={`contact_district`} field1="contact" field2="district" />
                </div>
                <div className="grupo-campo-mobile gcdade">
                  <input
                    type="text"
                    name="city"
                    placeholder="Cidade"
                    value={this.props.contact.city}
                    onChange={this.handleChange}
                    className={formErrors.city ? 'with-error' : ''}
                    onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_city')}
                  />
                  <ErrorMessage anchor={`contact_city`} field1="contact" field2="city" />
                </div>
                <div className="grupo-campo-mobile gestado">
                  <select
                    className={formErrors.state ? 'with-error' : ''}
                    name="state"
                    value={this.props.contact.state}
                    onChange={this.handleChange}
                    onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_state')}
                  >
                    <option value="">Estado</option>
                    {this.states.map((state, i) => (
                      <option
                        key={i}
                        value={state.value}
                        defaultValue={state.value === this.props.contact.state.toUpperCase()}
                      >
                        {state.name}
                      </option>
                    ))}
                  </select>
                  <ErrorMessage anchor={`contact_state`} field1="contact" field2="state" />
                </div>
              </div>
            </form>
            <ButtonStage data-cy="step-contact-data" index={4} stage="INSURED_RESP_CONTACT" />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    contact: state.purchase.contact,
    errors: state.purchase.errors,
    mobile: state.mobile.mobileActive,
    stagePurchase: state.purchase.stagePurchase,
    prospect: state.purchase.prospect,
    departure_date: state.purchase.quotationParams.departure_date,
    return_date: state.purchase.quotationParams.return_date,
    destination: state.purchase.quotationParams.destination,
    destinations: state.global.destinations || [],
  }),
  {
    changeContactAttr,
    finishPurchase,
    validatorHandlerBlur,
    clearInfosProspect,
  }
)(PurchaseContactMobile);



// WEBPACK FOOTER //
// ./src/components/purchase/purchase_contact/PurchaseContactMobile.jsx